import ClientManagementStore from "../../modules/Admin/ClientManagement/store";
import { ClientDto } from "../../modules/Admin/ClientManagement/types";
import { MessageResultState } from "../../types/general-types";

/**
 * Kullanıcının portal listesi için tek giriş noktası. İki tüketici aynı commit'te mount
 * oluyor (mega menü ve Portal Seçimi) ve her biri kendi isteğini attığında `get-user-clients`
 * iki kez çağrılıyordu; burada UÇUŞTAKİ istek paylaşılır. Sonuç önbelleğe ALINMAZ: promise
 * sonuçlanınca kayıt temizlenir, yoksa portal eklendiğinde liste bayat kalırdı.
 */
let pending: Promise<ClientDto[]> | null = null;

export function fetchUserClients(): Promise<ClientDto[]> {
  if (pending) return pending;

  pending = new ClientManagementStore()
    .getUserClients()
    .then((response) => {
      pending = null;
      // Hata toast'ını axios interceptor basıyor; burada liste boş kalır.
      if (response?.state !== MessageResultState.SUCCESS) return [];
      return response.result || [];
    })
    .catch(() => {
      pending = null;
      return [];
    });

  return pending;
}
